module.exports = __webpack_public_path__ + "fonts/GOTHICI.87a92153.TTF";